import { memo, Ref, useMemo } from "react";

import TableBodyRow from "ds/components/Table/Row";
import { TableColumnMeta } from "ds/components/Table/types";
import { isStickyLeft, isStickyRight } from "ds/components/TableSimple/helpers";
import { VcsProvider } from "types/generated";

import { ModulePullRequestsTableRow, ModulePullRequestsTableRunRow } from "../../gql";
import { MODULE_PULL_REQUESTS_RUN_CELLS } from "../Cells/Run";
import { ModulePullRequestsTableChildRow } from "../Cells/types";

type ModulePullRequestsTableRowRunProps = {
  pullRequest: ModulePullRequestsTableRow;
  run: ModulePullRequestsTableRunRow;
  moduleId: string;
  moduleProvider: VcsProvider;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: Ref<HTMLDivElement>;
  dataIndex: number;
};

const ModulePullRequestsTableRowRun = ({
  pullRequest,
  run,
  moduleId,
  moduleProvider,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
}: ModulePullRequestsTableRowRunProps) => {
  const item = useMemo<ModulePullRequestsTableChildRow>(
    () => ({ kind: "child", pullRequest, run }),
    [pullRequest, run]
  );

  return (
    <TableBodyRow
      {...keyboardProps}
      ref={measureRef}
      dataIndex={dataIndex}
      virtualized
      isGroupChild
      aria-level={2}
    >
      {columns.map((column, i) => {
        const Cell = MODULE_PULL_REQUESTS_RUN_CELLS[column.id];
        const cellId = `${pullRequest.id}-${run.id}-${column.id}`;

        return (
          <Cell
            key={cellId}
            id={cellId}
            item={item}
            moduleId={moduleId}
            moduleProvider={moduleProvider}
            isFirst={i === 0}
            stickyLeft={isStickyLeft(i, isFirstColumnPinned)}
            stickyRight={isStickyRight(i, columns.length)}
          />
        );
      })}
    </TableBodyRow>
  );
};

export default memo(ModulePullRequestsTableRowRun);
